import {
  takeLatest,
  put,
  select,
  call,
  cancel,
  delay,
  take,
} from 'redux-saga/effects';
import get from 'lodash/get';

import { getAppointmentId } from '../../../utils/paperwork';
import {
  redirectToPaperworkCompletedVisitDetails,
  redirectToPaperworkVisitDetails,
} from '../../../utils/paperwork/redirect-utils';

import {
  PAPERWORK_COMMON_ACTION_TYPES,
  paperworkCommonActions,
} from '../actions/common';

import { actions as permissionsActions } from '../../context/permissions';
import { manageInsurancesActions } from '../../manage-insurances/actions/manage-insurances-actions';
import {
  actions as paperworkUserDetailsActions,
  consts as paperworkUserDetailsConsts,
} from '../requests/paperwork-get-user-details';
import {
  actions as getPaperworkAppointmentDetailsActions,
  consts as getPaperworkAppointmentDetailsConsts,
} from '../requests/paperwork-get-appointment-details';
import { actions as getPaperworkAdditionalInfoActions } from '../requests/paperwork-get-additional-info';

import { selectAuthLoggedInStatus } from '../../auth/selectors';
import {
  loggedUserIdSelector,
  loggedUserSelector,
} from '../../context/selectors';
import {
  selectPaperworkAppointmentUserId,
  selectPaperworkAppointmentPaperworkCompleted,
  selectPaperworkAppointmentOrgId,
  selectPaperworkAppointmentServiceId,
} from '../selectors/paperwork-get-appointment-details';
import { actions as logoutAction } from '../../auth/logout';

function* handleValidateOnMount() {
  const isLoggedIn = yield select(selectAuthLoggedInStatus);

  if (!isLoggedIn) {
    yield cancel();
    return;
  }

  const appointmentUUID = yield call(getAppointmentId);

  yield put(
    getPaperworkAppointmentDetailsActions.send({
      appointmentUUID,
    }),
  );

  yield take(getPaperworkAppointmentDetailsConsts.SUCCEED);

  const userId = yield select(selectPaperworkAppointmentUserId);

  const loggedUserId = yield select(loggedUserIdSelector);

  const loggedUser = yield select(loggedUserSelector);

  const isAppointmentPaperworkCompleted = yield select(
    selectPaperworkAppointmentPaperworkCompleted,
  );

  const organizationId = yield select(selectPaperworkAppointmentOrgId);
  const serviceId = yield select(selectPaperworkAppointmentServiceId);
  const patientUserId = yield select(selectPaperworkAppointmentUserId);

  yield put(getPaperworkAdditionalInfoActions.clear());

  yield put(paperworkCommonActions.setPaperworkAdditionalInfoFormData(null));

  yield put(
    getPaperworkAdditionalInfoActions.send({
      serviceId,
      organizationId,
      patientUserId,
    }),
  );

  const hasUserAndLoggedUser = userId && loggedUserId;

  if (hasUserAndLoggedUser) {
    if (userId !== loggedUserId) {
      yield put(paperworkUserDetailsActions.send({ id: userId }));
      yield put(permissionsActions.update({ targetUserId: userId }));

      yield take([
        paperworkUserDetailsConsts.SUCCEED,
        paperworkUserDetailsConsts.REJECTED,
        paperworkUserDetailsConsts.ERROR_ENCOUNTERED,
      ]);
    } else {
      yield put(paperworkUserDetailsActions.setUserDetails(loggedUser));
    }
  }

  yield put(
    manageInsurancesActions.downloadPatientInsurancesData({
      userId,
    }),
  );

  if (isAppointmentPaperworkCompleted) {
    yield call(redirectToPaperworkCompletedVisitDetails, appointmentUUID);
  } else {
    yield call(redirectToPaperworkVisitDetails, appointmentUUID);
  }

  yield put(paperworkCommonActions.determinePaperworkFlowRoutes());

  yield delay(200);

  yield put(paperworkCommonActions.setGlobalPaperworkValidating(false));
}

function* clearGlobalPaperworkValidating(action) {
  if (get(action, 'payload.error.status') === 403) {
    yield put(logoutAction.send());
  } else {
    const appointmentUUID = yield call(getAppointmentId);

    yield call(redirectToPaperworkVisitDetails, appointmentUUID);
  }

  yield delay(200);

  yield put(paperworkCommonActions.setGlobalPaperworkValidating(false));

  yield put(paperworkCommonActions.setGlobalPaperworkPending(false));
}

export function* validateInitialPaperworkPage() {
  yield takeLatest(
    PAPERWORK_COMMON_ACTION_TYPES.VALIDATE,
    handleValidateOnMount,
  );

  yield takeLatest(
    [
      getPaperworkAppointmentDetailsConsts.REJECTED,
      getPaperworkAppointmentDetailsConsts.ERROR_ENCOUNTERED,
    ],
    clearGlobalPaperworkValidating,
  );
}



// WEBPACK FOOTER //
// ./src/redux/paperwork/sagas/validate-initial-paperwork-page.js